
    import store from '@/store'
    import CertService from '@/service/CertService'

    export default {
        name: 'CertLayer',
        computed: {
            user() {
                return store.getters.getUser;
            }
        },
        data() {
            return {
                popup: {},
                visible: false,
                isLoading: false,
            }
        },
        methods: {
            show() {
                //if (process.env.NODE_ENV == 'development') {
                //    return;
                //}

                this.visible = true;
                this.isLoading = true;
            },
            hide() {
                this.visible = false;
                this.isLoading = false;
            },
            request() {
                CertService.get_cert_url({
                    return_url: `${location.origin}/pay/cp/NiceResult.aspx`,
                    close_url: '',
                }, ({ data }) => {
                    const { result_code, result_message } = data;

                    // 정상처리
                    if (result_code === '0000') {
                        this.certData = data;
                        this.popup = window.open(data.auth_url, 'popupCert', 'width=500, height=500, top=100, left=100, fullscreen=no, menubar=no, status=no, toolbar=no, titlebar=yes, location=no, scrollbar=no');
                    }
                    else {
                        alert(result_message);
                    }
                });
            },
            certResult(web_transaction_id) {
                CertService.get_cert_result({
                    access_token: this.certData.access_token,
                    request_no: this.certData.request_no,
                    transaction_id: this.certData.transaction_id,
                    web_transaction_id,
                }, ({ data }) => {
                    const { result_code, result_message } = data;
                    this.popup.close();
                    // 정상처리
                    if (result_code === '0000') {
                        this.certDecode(data);
                    }
                    else {
                        alert(result_message);
                    }
                });
            },
            certDecode(r) {
                const { enc_data, integrity_value } = r;
                CertService.get_cert_decode({
                    request_no: this.certData.request_no,
                    enc_data,
                    integrity_value,
                    ticket: this.certData.ticket,
                    transaction_id: this.certData.transaction_id,
                    iterators: this.certData.iterators,
                }, (res) => {
                    const { result_code, result_message } = res.data;
                    if (result_code === '0000') {
                        const { data } = res.data;

                        // 리얼일때만 신도정보 체크하도록
                        if (process.env.NODE_ENV !== 'production' || (
                            data.birthdate.sub(2).trim() === this.api.birth_date.trim() &&
                            data.name.trim() === this.api.user_name.trim()
                        )) {
                            CertService.set_cert_check({
                                CMD: 'U',
                                JSD_USER_CD: this.user.JSD_USER_CD,
                            }, async ({ data }) => {
                                if (data.RESULT > 0) {
                                    this.hide();
                                    await this.$root.sessionUpdate();
                                }
                                else {
                                    alert(data.RESULT_MESG);
                                }
                            });
                        }
                        else {
                            alert('본인인증 정보와 신도정보가 일치하지 않습니다.');
                        }
                    }
                    else {
                        alert(result_message);
                    }
                });
            }
        },
        mounted() {
            this.$$on(this, 'certCallback', (r) => {
                const { detail } = r;
                this.certResult(detail[0]);
            })
        }
    }
